import Zone from "@insite/client-framework/Components/Zone";
import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface OrderHistoryHeaderStyles {
    container?: GridContainerProps;
    invoiceCountGridItem?: GridItemProps;
    emptyGridItem?: GridItemProps;
    toggleFilterGridItem?: GridItemProps;
    toggleFilterIcon?: IconPresentationProps;
    toggleFilterClickable?: ClickablePresentationProps;
}

export const headerStyles: OrderHistoryHeaderStyles = {
    container: {
        gap: 8,
        css: css`
            padding-bottom: 20px;

            @media (max-width: 1279px) {

                > div {
                    justify-content: space-between;
                }
            }
        `,
    },
    invoiceCountGridItem: {
        style: { fontWeight: 600 },
        css: css`
            max-width: none;
            flex-basis: unset;
        `,
    },
    toggleFilterGridItem: {
        style: { justifyContent: "flex-end" },
        css: css`
            max-width: none;
            flex-basis: unset;
        `,
    },
    toggleFilterIcon: {
        src: Filter,
        size: 18,
        css: css`
            display: inline-block;
            margin-right: 8px;
        `,
    },
    toggleFilterClickable: {
        css: css`
            padding-left: 15px;
            margin-left: 15px;
            border-left: 1px solid #E4E8F0;
            min-width: 123px;

            &.hide-btn {
                display: none;
            }

            span.label {
                color: #002554;
                font-family: 'Lato',sans-serif;
                font-size: 14px;
                letter-spacing: 0;
            }
        `,
    }
};
const styles = headerStyles;

const OrderHistoryHeader: FC<Props> = ({ toggleFiltersOpen, id }) => {
    const ordersDataView = useContext(OrdersDataViewContext);
    if (!ordersDataView.value || !ordersDataView.pagination) {
        return null;
    }
    const { totalItemCount } = ordersDataView.pagination;
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.invoiceCountGridItem}>
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
            <GridItem {...styles.toggleFilterGridItem}>
                <Clickable
                    {...styles.toggleFilterClickable}
                    onClick={() => toggleFiltersOpen()}
                    data-test-selector="orderHistory_showHideFilters"
                    className={`toggleFilters ${(totalItemCount === 0) ? "hide-btn" : "show-btn"}`}
                >
                    <Icon {...styles.toggleFilterIcon} />
                    <span className="label">{translate("Filter orders")}</span>
                </Clickable>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(OrderHistoryHeader),
    definition: {
        group: "Order History",
        displayName: "Header",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
